var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknownLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47008 0C1.11154 0 0 1.125 0 2.5V37.5C0 38.875 1.11154 40 2.47008 40H27.1709C28.5294 40 29.6409 38.875 29.6409 37.5V10L19.7606 0H2.47008Z",
    fill: "#FFE190"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4502 10H29.6425L20.0527 0V7.5C20.0527 8.875 21.1316 10 22.4502 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.642 17.2727L21.7959 10H29.642V17.2727Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownLogo);
export default __webpack_public_path__ + "static/media/unknown-logo.994d1cca954beb5a4ef213f65e54fea6.svg";
export { ForwardRef as ReactComponent };